import React from 'react';

const SplitSection = ({ id, primarySlot, secondarySlot, reverseOrder }) => (
  <section id={id} className="max-w-7xl mx-auto py-10 pl-5 sm:pl-7 lg:pl-9">
    <div className="flex items-center justify-between mx-auto">
      <div className="my-15 w-1/2">{primarySlot}</div>
      <div className={`w-1/2 ${reverseOrder && `order-first`}`}>{secondarySlot}</div>
    </div>
  </section>
);

export default SplitSection;
